import React, { useState, useEffect } from 'react'
import { Years } from './style'
import { orange } from '../../../styles/colors'
import useWindowSize from '../../../hooks/window/WindowSize'
import type { CarouselMark } from './types'

/** Largura fixa do rótulo do ano (px), igual ao `width` do h2. */
const YEAR_ITEM_WIDTH_PX = 214
/** Distância horizontal entre anos no trilho (px). */
const YEAR_TRACK_GAP_PX = 265

/** Remove `&nbsp;`/espaços à esquerda usados no JSON para alinhamento antigo; evita o ano “sozinho” parecer deslocado à direita. */
function trimYearHtml (yearHtml: string): string {
  return yearHtml.replace(/^(?:&nbsp;|\s)+/gi, '')
}

interface ITimelinesYears {
  carouselIndexData: React.SetStateAction<number>;
  NossaTrajetoriaJSON: CarouselMark[];
}

const TimelineYears = ({ carouselIndexData, NossaTrajetoriaJSON }: ITimelinesYears) => {
  const data = NossaTrajetoriaJSON
  const windowWidth = useWindowSize().sizes.width
  const [ carouselIndex, setCaroulselIndex ] = useState(0)

  useEffect(() => {
    setCaroulselIndex(carouselIndexData)
  }, [ carouselIndexData ])

  const activeYearLeft =
    windowWidth / 2 - YEAR_ITEM_WIDTH_PX / 2

  return (
    <Years>
      <div className='d-flex justify-content-center'>
        {data.map((item: CarouselMark, index: number) =>
          (
            <h2
              className='fs-16 fs-md-38 lh-46 text-center'
              dangerouslySetInnerHTML={{ __html: trimYearHtml(item.year) }}
              key={index}
              style={{
                color: `${carouselIndex === item.id ? orange.extra : '#F7CA96'}`,
                transform: `${carouselIndex === item.id ? 'scale(1.2)' : 'scale(0.9)'}`,
                width: `${YEAR_ITEM_WIDTH_PX}px`,
                position: 'absolute',
                zIndex: 2,
                transition: 'left 0.5s, transform 0.3s ease-in-out',
                left: `${activeYearLeft + (index - carouselIndex) * YEAR_TRACK_GAP_PX}px`,
              }}
            />
          ))}
      </div>
    </Years>
  )
}

export default TimelineYears
